import { __assign } from '../../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import styles from './Skeleton.module.scss.js';

var Skeleton = function (_a) {
    var _b, _c;
    var className = _a.className, style = _a.style, _d = _a.size, size = _d === void 0 ? 'm' : _d;
    return (jsxs("div", __assign({ className: clsx(styles.field, className), style: style, "data-testid": "input-skeleton" }, { children: [jsx("div", { className: clsx(styles.fieldLabel, (_b = {},
                    _b[styles.fieldLabelMedium] = size === 'm',
                    _b[styles.fieldLabelLarge] = size === 'l',
                    _b)) }), jsx("div", { className: clsx(styles.fieldInput, (_c = {},
                    _c[styles.fieldInputMedium] = size === 'm',
                    _c[styles.fieldInputLarge] = size === 'l',
                    _c)) })] })));
};

export { Skeleton };
